// extracted by css-extract-rspack-plugin
export default {"keyInput":"JajWL"};